/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_filters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_filters" | "SbSharedRefineMenuDisplayPrefsSelect_filters">;
    readonly " $refType": "SbRespRefineMenu_filters";
}>;
export type SbRespRefineMenu_filters$data = SbRespRefineMenu_filters;
export type SbRespRefineMenu_filters$key = ReadonlyArray<{
    readonly " $data"?: SbRespRefineMenu_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_filters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
      "args": null
    }
  ]
};
(node as any).hash = 'fbe4a3afa9de14b2bf5167e3b6714133';
export default node;
